import posthog from "posthog-js";

const POSTHOG_KEY = "phc_qQNBo5HVeAQr35tN4QZoENibdatdfrrMSLwVXfHNYuDh";
const POSTHOG_HOST = "https://us.i.posthog.com";

let initialized = false;

export function initPostHog() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    capture_pageview: false, // we capture manually on route change
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: true,
  });
}

export { posthog };
